import classNames from 'classnames';
import Headlines from '../../atom/Headlines';
import InfoBannerCommon from '../InfoBannerCommon';
import { InfoBannerProps } from './index';

const componentName = 'info-banner';

/**
 * This component renders a dismisable banner.
 */
function InfoBanner({
    anchor,
    id,
    headlines,
    icon,
    style,
    showCloseTrigger,
    dismissalKey,
    backgroundColor,
    fontcolor: textColor,
}: InfoBannerProps): JSX.Element {
    return (
        <InfoBannerCommon
            anchor={anchor}
            backgroundColor={backgroundColor}
            dismissalKey={dismissalKey ?? id}
            icon={icon}
            showCloseTrigger={showCloseTrigger}
            style={style}
            text={
                <Headlines
                    className={classNames(
                        !icon ? `${componentName}__centered-headlines` : `${componentName}__headlines`
                    )}
                    {...headlines}
                    textColor={textColor}
                />
            }
        />
    );
}

export default InfoBanner;
